/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-08-25 10:00:55 */

const Keys = {
  total: 'total',
  basePrice: 'basePrice',
  extension: 'extension',
  with: 'with',
  numberOfPerson: 'numberOfPerson',
  numberOfPerson_plural: 'numberOfPerson_plural',
  participant: 'participant',
  totalPerPerson: 'totalPerPerson',
  voucher: 'voucher',
  airportSurcharge: 'airportSurcharge',
  airportDiscount: 'airportDiscount',
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
  OPTIONAL_plural: 'OPTIONAL_plural',
  MAIN: 'MAIN',
  yourHotel: 'yourHotel',
  yourRoom: 'yourRoom',
  yourMeal: 'yourMeal',
  seasonalSurcharges: 'seasonalSurcharges',
  seasonalDiscount: 'seasonalDiscount',
  yourBusStop: 'yourBusStop',
  busStopSurcharge: 'busStopSurcharge',
  busStopDiscount: 'busStopDiscount'
}; export default Keys;